<template>
  <div class="d-flex flex-column h-100 bg-dark ">
          <nav>
            <router-link to="/">短码</router-link> |
            <router-link to="/l">长码</router-link>
          </nav>

          <div class="container-fluid pt-0 mt-0 px-0  flex-grow-1 d-flex flex-column justify-content-center" >
            <router-view/>
          </div>

          <div class=" pt-3 pb-3 d-flex flex-column">
            <span class="copyright">油画空间提供大量油画作品鉴赏，如有侵权，请联系删除！</span>
            <span class="copyright">Powered by wilder. {{ currYear }}</span>
            <a href="https://beian.miit.gov.cn/" target="_blank" class="beian">蜀ICP备2023013983号-3</a>

          </div>
  </div>
</template>
<script>
export  default {
  name:"App",
  data(){
    return {
      currYear:"",

    }
  },
  mounted() {
    this.getDate()
  },
  methods: {
    getDate(){
      const currentDate = new Date();
      this.currYear = currentDate.getFullYear();  // 返回当前年份
    }
  }
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
.copyright{
  font-size: xx-small;
  color: darkgray;
}
.beian{
  font-size: 9px;
  color: darkgray;
  text-decoration: none;
}
</style>
